import { KeyMetricStatement, StarSolidSVG } from './styled';
import { Grid } from '@simplywallst/ui-core';
import If from '@/components/If';
import { useValuationData } from '@/pages/CompanyReport/components/Valuation';
import type { Multiple } from '@/pages/CompanyReport/components/Valuation/components/KeyValuationMetrics';
import Description from '@/components/Statement/components/Description';
import { useCompanyCanonicalUrl } from '@/hooks/useCompany';
import useCompanyStatementsAPIFormatted from '@/hooks/useCompanyStatementsAPIFormatted';
import { useValuationTranslation } from '@/pages/CompanyReport/components/Valuation/hooks/useValuationTranslation';

interface Props {
  multiple: Multiple;
}

export const KeyMetricsStatements = ({ multiple }: Props) => {
  const selected = useValuationData();
  const canonicalURL = useCompanyCanonicalUrl();
  const { data: statements } = useCompanyStatementsAPIFormatted({
    canonicalURL,
  });

  const {
    multiples: { preferredMultiple, secondMultiple, thirdMultiple },
  } = selected;

  const t = useValuationTranslation();

  return (
    <KeyMetricStatement data-cy-id="key-metric-statement">
      <If
        conditions={{
          preferred: multiple.name === preferredMultiple.name,
          second: multiple.name === secondMultiple.name,
          third: multiple.name === thirdMultiple.name,
          others: multiple.name === 'n/a',
        }}
      >
        {{
          preferred: () => (
            <Grid gap="10px" templateRows="auto" templateColumns="30px auto">
              <Grid justifyContent="center">
                <StarSolidSVG />
              </Grid>
              <Grid>
                <p>
                  <mark>{t('keyMetric.statements.keyMetric')}</mark>
                  <Description statement={statements?.HasPreferredMultiple} />
                </p>
              </Grid>
            </Grid>
          ),
          second: () => (
            <p>
              <Description statement={statements?.HasSecondaryMultiple} />
            </p>
          ),
          third: () => (
            <p>
              <Description statement={statements?.HasTertiaryMultiple} />
            </p>
          ),
          others: () => <p>{t('keyMetric.statements.others')}</p>,
        }}
      </If>
    </KeyMetricStatement>
  );
};
